export default __webpack_public_path__ + "static/media/needle.55668eef.png";